import moment from 'moment'

export const useTimeFormatter = (timeSlot: number) => {
  return moment().startOf('day').seconds(timeSlot).format('mm:ss')
}
